import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
//import "./utils/directives.js"; //引入弹窗控件功能，不能调整大小，所以不用了。
import './utils/dialog.js'; //引入对护框拖动调整大小组件
import SlideVerify from 'vue-monoplasty-slide-verify'; // 引入滑动拼图验证
import "./api/plugins/axios"
import scm from "./api/plugins/scm"; // 引入封装的接口类
import Cookie from 'js-cookie'
import store from './store'
import Schema from 'async-validator'
import { insertVersionFile } from '@/utils/version'


Vue.config.productionTip = false;

// 全局引入element组件
Vue.use(ElementUI);

// 全局使用工具库
import utils from './utils/utils'
Vue.prototype.$utils = utils; // 之后使用直接$utils

// 全局引入滑动拼图验证
Vue.use(SlideVerify);


// 全局使用cookie
Vue.prototype.$cookie = Cookie;

// 清除内容的方法
function clearSomething() {
  sessionStorage.clear();
  localStorage.removeItem('token');
  localStorage.removeItem('onCompanyId');
  localStorage.removeItem('onCompany');
  localStorage.removeItem('uid');
  localStorage.removeItem('userIdentity');
  // Cookie.remove('token');
  // Cookie.remove('identity');
  // Cookie.remove('uid');
}

// 添加全局前置导航守卫
router.beforeEach((to, from, next) => {
  // 插入并且检查版本号
  insertVersionFile();
  // handleVersion();

  // 判断token存不存在,不存在说明当前用户是未登录状态，应该跳转到登陆页
  //let token = Cookie.get('token');
  //let c_identity = Cookie.get('identity');
  let token = localStorage.getItem("token");
  let c_identity = localStorage.getItem("userIdentity");
  // let s_identity = sessionStorage.getItem('userIdentity');
  let s_identity = localStorage.getItem('userIdentity');
  //let uid = Number(Cookie.get('uid'));
  let uid = localStorage.getItem("uid");
  let toID = to.params.id;
  Schema.messages.required = fieldName => {
    return '该项为必填项'
  };
  // console.log('要去的path是', to.name, to.path); // login /login， 要去根目录就不一样了是 root /  路由的name和path是根据router中定义的来的

  if (!token && to.name !== 'login') { // token失效跳转到登录
    clearSomething();
    next({ name: 'login' })
  } else if (token && to.path === '/') { // 直接访问根路径跳转到登录
    clearSomething();
    next({ name: 'login' })
    // eslint-disable-next-line no-dupe-else-if
   } else if (token && to.path !== '/' && (toID != uid || s_identity != c_identity)) {
    clearSomething();
    next({ name: 'login' })
   } else {
  // } else {
    next()
  }

});

//router.beforeEach((to, from, next) => {
//  // 判断token存不存在,不存在说明当前用户是未登录状态，应该跳转到登陆页
//  //let token = Cookie.get('token');
//  //let c_identity = Cookie.get('identity');
//  let token = localStorage.getItem("token");
//  let c_identity = localStorage.getItem("userIdentity");
//  // let s_identity = sessionStorage.getItem('userIdentity');
//  let s_identity = localStorage.getItem('userIdentity');
//  //let uid = Number(Cookie.get('uid'));
//  let uid = localStorage.getItem("uid");
//  let toID = to.params.id;
//  Schema.messages.required = fieldName => {
//    return '该项为必填项'
//  };
//  // console.log('当前用户：', uid, c_identity, '会话窗口的用户是：', s_identity);
//  // console.log('下一个路由是：', to.name, toID);
//  // console.log('要去的path是', to.name, to.path); // login /login， 要去根目录就不一样了是 root /  路由的name和path是根据router中定义的来的
//
//  if (!token && to.name !== 'login') { // token失效跳转到登录
//    // sessionStorage.clear();
//    localStorage.clear();
//    sessionStorage.clear();
//    //Cookie.remove('token');
//    //Cookie.remove('identity');
//    //Cookie.remove('uid');
//    // scm.User.logout()
//    next({ name: 'login' })
//  } else if (token && to.path === '/') { // 直接访问根路径跳转到登录
//    localStorage.clear();
//    sessionStorage.clear();
//    //Cookie.remove('token');
//    //Cookie.remove('identity');
//    //Cookie.remove('uid');
//    // scm.User.logout()
//    next({ name: 'login' })
//    // eslint-disable-next-line no-dupe-else-if
//   } else if (token && to.path !== '/' && (toID != uid || s_identity != c_identity)) {
//     //Cookie.remove('token');
//     //Cookie.remove('identity');
//     //Cookie.remove('uid');
//     sessionStorage.clear();
//     localStorage.clear();
//     next({ name: 'login' })
//   } else {
//  // } else {
//    next()
//  }
//});



// Broadcast Channel API，它允许同源的窗口之间进行通信，当一个窗口中的数据发生变化时，它可以向 Broadcast Channel 发送消息，其他窗口监听该频道，接收消息后刷新页面
// 1.创建一个 Broadcast Channel
const channel = new BroadcastChannel('change-company');

// 2.监听消息
channel.onmessage = function (event) {
  if (event.data === 'refresh') {
    location.reload();
  }
};

// 3.添加事件监听器
document.addEventListener('DOMContentLoaded', () => {
  window.addEventListener('storage', function (event) {
    console.log('事件是：' + event); // // Noncompliant: no checks are done on the origin property.  event.origin !== "http://example.org"
    if (event.key === 'onCompany') {
      location.reload();
    }
  });
});
Vue.config.productionTip = false; // 控制着在启动应用时是否显示生产提示信息


new Vue({
  router,  // 挂载router
  store, // 挂载vuex
  render: h => h(App),
}).$mount('#app');
